
import { useState, useEffect } from 'react';
import PartnerHero from './components/PartnerHero';
import PartnerContent from './components/PartnerContent';
import PartnerForm from './components/PartnerForm';
import PartnerFooter from './components/PartnerFooter';

export default function Partner() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Track scroll position to toggle header background
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const navLinks = [
    { href: '/#about', label: '会社概要' },
    { href: '/#services', label: 'サービス概要' },
    { href: '/partner', label: '協力会社募集' },
    { href: '/recruit', label: '正社員募集' },
    { href: '/#contact', label: 'お問い合わせ' },
  ];

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer group">
            <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg overflow-hidden shadow-sm group-hover:shadow-md transition-shadow bg-white flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/0f43beb23aaca34fe525f322afdb3a4e/91f45852d6469a87479e767848617524.jpeg"
                alt="Refresh Labo ロゴ"
                className="w-full h-full object-cover"
              />
            </div>
            <span
              className="text-base sm:text-lg font-bold tracking-wide"
              style={{ color: isScrolled ? '#000' : '#fff' }}
            >
              Refresh Labo
            </span>
          </a>

          {/* Desktop navigation */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium hover:opacity-70 transition-opacity cursor-pointer ${
                  isScrolled ? 'text-gray-800' : 'text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile hamburger button */}
          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="メニュー"
          >
            <i
              className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden fixed inset-0 top-[56px] bg-white z-40">
            <div className="flex flex-col px-6 py-6 gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="text-base font-medium text-gray-800 py-3 border-b border-gray-100 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>

      <PartnerHero />
      <PartnerContent />
      <PartnerForm />
      <PartnerFooter />
    </div>
  );
}
